import React, {Fragment} from "react";
import SweetAlertBase from "./SweetAlertBase";
import SVG from "react-inlinesvg";
import shareReportSVG from "../../../assets/svg/ils/ils-share-report.svg";
// import "../../../assets/sass/pages/scouting/shared-done-modal.scss";

class SA_ShareDone extends SweetAlertBase {

    html =  (
        <Fragment>
            <SVG src={shareReportSVG}/>
            <h2>Share Scouting Reports</h2>
            <p>Please search and select the participants you want to share the scouting reports</p>
        </Fragment>
    );

    type() {
        return 'sm';
    }

    className() {
        return "share-done";
    }

    confirmButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }
};

export default SA_ShareDone;